module.exports = __webpack_public_path__ + "img/frame17_stamp.91b4005d.png";